import React from "react";
import CircleBlue from "../assets/images/Decos/Ellipse 6.png";
import Lineleft from "../assets/images/Decos/left-atene.png";
import Lineright from "../assets/images/Decos/radar-antenne-radio-directionnelle-avec-antenne-parabolique-.png";
import user1 from "../assets/images/user/Group 2607.png";
import cover4 from "../assets/images/user/Jean-Paul-Rudant 1.jpeg";

// Composant pour les images décoratives
const DecorativeImage = ({ src, alt, className, style }) => (
  <img src={src} alt={alt} className={className} style={style} loading="lazy" />
);

function Title() {
  return (
    <div className="bg-home text-center pt-16 md:pt-24 pb-48" id="acceuil">
      {/* Décorations */}
      <div className="absolute hidden 2xl:block my-52">
        <DecorativeImage
          src={CircleBlue}
          alt="Circle Blue decoration"
          className="2xl:ml-[1570px] lg:ml-[1500px] -mt-[80px]"
        />
        <DecorativeImage
          src={Lineleft}
          alt="Line left decoration"
          className="absolute 2xl:mr-[1750px] 2xl:top-52 2xl:left-[14%]"
        />
        <DecorativeImage
          src={Lineright}
          alt="Line right decoration"
          className="absolute 2xl:ml-[1750px] 2xl:top-52 2xl:-right-24"
        />
      </div>

      {/* Carte utilisateur */}
      <div className="flex justify-center mt-2">
        <div className="flex justify-between items-center w-auto xl:w-auto xl:h-auto md:w-auto md:h-auto sm:w-auto sm:h-auto border border-gray-400 rounded-[40px] px-2 py-2 card-paul bg-gray-200">
          <DecorativeImage
            src={cover4}
            alt="Jean-Paul Rudant"
            className="xl:w-[50px] xl:h-[50px] sm:w-auto sm:h-auto md:w-[45px] md:h-[45px] w-[30px] h-[30px] object-cover rounded-full mr-2"
          />
          <div className="xl:py-2 pr-2">
            <span
              style={{ color: "#FF5252" }}
              className="sm:font-black xl:text-[20px] sm:text-[18px] text-[15px]  md:text-[22px]"
            >
              Jean-Paul Rudant et son équipe
            </span>
          </div>
        </div>
      </div>

      {/* Titre */}
      <div className="relative text-radar-title">
        <h1 className="mx-10 sm:mx-20 md:mx-28 lg:mx-40 pt-10 xl:text-[3rem]">
          Comprenez et maîtrisez l'
          <span className="text-blue-300">analyse</span> et le{" "}
          <span className="text-blue-300">
            <br className="hidden md:block" />
            Traitement
          </span>{" "}
          des Images Satellitaires <span className="text-blue-300">Radar</span>
        </h1>
      </div>
      {/* Description */}
      <p className="text-radar container mx-auto mb-4 mt-6">
        Apprenez à interpréter et traiter les images satellitaires radar grâce à
        des cours en malgache et en français.
      </p>
      {/* Image utilisateur */}
      <div className="flex justify-center mb-16 mt-12 sm:mt-4">
        <DecorativeImage src={user1} alt="Rebecca" />
      </div>
    </div>
  );
}

export default Title;
